import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { LARGE_MARGIN, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      background: theme.palette.secondary.light,
      padding: `${MIDDLE_MARGIN}px 0`,
      [theme.breakpoints.up('md')]: {
        padding: `${LARGE_MARGIN}px 0`,
      },
    },
    title: {
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: 24,
      lineHeight: 1.2,
      marginBottom: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginBottom: MIDDLE_MARGIN,
        fontSize: 28,
      },
    },
    pathwaysWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      boxSizing: 'content-box',
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'center',
      },
    },
    pathwayItemWrapper: {
      paddingTop: 20,
      height: 240,
      width: '100%',
      marginBottom: SMALL_MARGIN,
      maxWidth: 400,
      zIndex: 1,
      '&:last-child': {
        marginBottom: 0,
      },
      [theme.breakpoints.up('md')]: {
        width: '33%',
        marginRight: SMALL_MARGIN,
        marginBottom: 0,
        height: 316,
        maxWidth: '100%',
        '&:last-child': {
          marginRight: 0,
        },
      },
    },
    pathwayItem: {
      marginRight: 24,
    },
  }),
);

export default useStyles;
